import { queryOptions, useQuery } from '@tanstack/react-query'
import { CurrentUser } from './CurrentUser'
import { getUser } from './getUser'
import { QUERY_KEYS } from './queryKey'

export const profileQuery = queryOptions({
  queryKey: QUERY_KEYS.profile,
  queryFn: getUser,
  staleTime: Infinity,
  gcTime: Infinity,
  refetchOnWindowFocus: false,
})

export const useCurrentUser = <T = CurrentUser>(
  select?: (data: CurrentUser) => T,
) => {
  const { data } = useQuery({ ...profileQuery, select })

  return data!
}
